module.exports = __webpack_public_path__ + "static/img/img-about-13.59d477a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-13.png
// module id = LJYy
// module chunks = 0